import React, { useEffect, useState } from "react";
import {
  AiFillHeart,
  AiOutlineHeart,
  AiOutlineShoppingCart,
} from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  addToWishlist,
  removeFromWishlist,
} from "../../redux/actions/wishlist";
import { Link } from "react-router-dom";
import "./SubProductCard.scss";

const SubProductCard = ({ subProduct, addToCartHandler }) => {
  const { wishlist } = useSelector((state) => state.wishlist);
  const [click, setClick] = useState(false);
  const [animate, setAnimate] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (wishlist && wishlist.find((i) => i._id === subProduct._id)) {
      setClick(true);
    } else {
      setClick(false);
    }
  }, [wishlist, subProduct._id]);

  const removeFromWishlistHandler = (subProduct) => {
    setClick(!click);
    dispatch(removeFromWishlist(subProduct));
  };

  const addToWishlistHandler = (subProduct) => {
    setAnimate(true);
    setClick(!click);
    dispatch(addToWishlist(subProduct));
    setTimeout(() => setAnimate(false), 400);
  };
  const hasDiscount =
    subProduct.discountPrice &&
    subProduct.discountPrice !== subProduct.price;

  const localePrice = (val) => val?.toLocaleString("uk-UA") ?? "0";

  return (
    <div className="subproduct-card" key={subProduct._id}>
      <Link to={`/subproduct/${subProduct._id}`}>
        {subProduct.images && subProduct.images.length > 0 ? (
          <div className="subproduct-card__image-container">
            <img
              src={`${subProduct.images[0]?.url}`}
              alt=""
              className="subproduct-card__image"
              onError={(e) => {
                e.target.src = "/placeholder-image.jpg";
              }}
            />
          </div>
        ) : (
          <p className="subproduct-card__no-image">
            Для данного компонента, нажаль, немає фото.
          </p>
        )}
      </Link>

      <div className="subproduct-card__icons">
        {click ? (
          <AiFillHeart
            className={`subproduct-card__heart-icon ${
              animate ? "heartbeat" : ""
            }`}
            onClick={() => removeFromWishlistHandler(subProduct)}
            title="Remove from wishlist"
          />
        ) : (
          <AiOutlineHeart
            className="subproduct-card__heart-icon--outline"
            onClick={() => addToWishlistHandler(subProduct)}
            title="Add to wishlist"
          />
        )}

        <AiOutlineShoppingCart
          className="subproduct-card__cart-icon"
          onClick={() => addToCartHandler(subProduct)}
          title="Add to cart"
        />
      </div>

      <h4 className="subproduct-card__title">{subProduct.name}</h4>

      {subProduct.features && (
        <ul className="subproduct-card__features">
          {Object.entries(subProduct.features).map(([key, value]) => (
            <li key={key}>
              {key}: {value}
            </li>
          ))}
        </ul>
      )}

      <div className="subproduct-card__pricing-wrapper">
        {hasDiscount && (
          <div className="subproduct-card__old-price">
            <del>{localePrice(subProduct.price)} грн</del>
          </div>
        )}

        <div className="subproduct-card__price-row">
          <h4 className="subproduct-card__price">
            {hasDiscount
              ? `${localePrice(subProduct.discountPrice)} грн`
              : `${localePrice(subProduct.price)} грн`}
          </h4>

          <button
            className="subproduct-card__add-to-cart-btn"
            onClick={() => addToCartHandler(subProduct)}
          >
            <span className="subproduct-card__btn-icon--mobile">
              <AiOutlineShoppingCart size={13} />
            </span>
            <span className="subproduct-card__btn-text--desktop">
              В кошик
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubProductCard;
